/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Search_Value_DaysInputs */

const en_us2_search_value_days = /** @type {(inputs: Search_Value_DaysInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} a week`)
};

const pt_br2_search_value_days = /** @type {(inputs: Search_Value_DaysInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} por semana`)
};

const es_419_search_value_days = /** @type {(inputs: Search_Value_DaysInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} por semana`)
};

const pt_pt2_search_value_days = /** @type {(inputs: Search_Value_DaysInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} por semana`)
};

const fr_fr2_search_value_days = /** @type {(inputs: Search_Value_DaysInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} par semaine`)
};

const de_de2_search_value_days = /** @type {(inputs: Search_Value_DaysInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count}-mal pro Woche`)
};

const it_it2_search_value_days = /** @type {(inputs: Search_Value_DaysInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} a settimana`)
};

/**
* | output |
* | --- |
* | "{count} a week" |
*
* @param {Search_Value_DaysInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const search_value_days = /** @type {((inputs: Search_Value_DaysInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Search_Value_DaysInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_search_value_days(inputs)
	if (locale === "es-419") return es_419_search_value_days(inputs)
	if (locale === "pt-PT") return pt_pt2_search_value_days(inputs)
	if (locale === "fr-FR") return fr_fr2_search_value_days(inputs)
	if (locale === "de-DE") return de_de2_search_value_days(inputs)
	if (locale === "it-IT") return it_it2_search_value_days(inputs)
	return en_us2_search_value_days(inputs)
});
export { search_value_days as "search.value_days" }